import React from "react";
import {
  AiOutlineEye,
  AiOutlineHeart,
  AiOutlineShoppingCart,
} from "react-icons/ai";

import { NavLink } from "react-router-dom";

import { useDispatch } from "react-redux";
import { addToCart, addToWhishList } from "../actions/action";

function Product(props) {
  const imageArray = new Uint8Array(props.product.image.data.data);
  let str = "";
  for (let i = 0; i < imageArray.length; i++) {
    str += String.fromCharCode(imageArray[i]);
  }
  const base64String = btoa(str);
  const encodedImage = `data:mimeType;base64,${base64String}`;
  const dispatch = useDispatch();
  return (
    <div className="group mb-4 ml-2 w-[250px] h-[250px] flex flex-col justify-center items-center rounded-2xl border border-primary pt-4 pb-4 pl-24 pr-24">
      <img className="pb-8" src={encodedImage} alt="productImage" />
      <div className="flex group-hover:hidden flex-col">
        <span
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxHeight: "3.2em",
            lineHeight: "1.6em",
            width: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          className="text-left pb-2 text-lg text-primary"
        >
          {props.product.title}
        </span>
        <span className="text-left pb-2 text-lg text-secondary">
          {props.product.category}
        </span>
        <span className="text-left text-lg text-primary">
          ${props.product.price}
        </span>
      </div>
      <div className="hidden group-hover:flex items-center justify-center">
        <button
          onClick={() =>
            dispatch(
              addToCart({
                id: props.product._id,
                category: props.product.category,
                name: props.product.title,
                price: props.product.price,
                image: encodedImage,
                quantity: props.product.quantity,
              })
            )
          }
          className="flex w-[170px] justify-center items-center mr-[-30px] pt-2 pb-2 pl-2 pr-2 text-white bg-secondary outline-none border rounded-lg"
        >
          <span className="pr-3 text-black">Add To Cart</span>
          <AiOutlineShoppingCart size="30" color="white" />
        </button>
        <button
          onClick={() =>
            dispatch(
              addToWhishList({
                id: props.product._id,
                category: props.product.category,
                name: props.product.title,
                price: props.product.price,
                image: encodedImage,
                quantity: props.product.quantity,
              })
            )
          }
          className="p-2 relative bottom-32 left-8 text-primary bg-secondary outline-none rounded-full"
        >
          <AiOutlineHeart color="black" />
        </button>
        <NavLink to={`/product/${props.product._id}`}>
          <button className="p-4 text-primary bg-secondary outline-none border rounded-lg">
            <AiOutlineEye color="black" />
          </button>
        </NavLink>
      </div>
    </div>
  );
}

export default Product;
